import * as Sentry from '@sentry/react';
import palette from '../../common/theme/palette';
import { loadImage, prepareIcon } from './mapUtil';

import arrowPng from '../../resources/images/arrow.png';
import backgroundSvg from '../../resources/images/background.svg';
import altbackgroundSvg from '../../resources/images/background_invisible.svg';
import clusterSvg from '../../resources/images/backgroundCluster.svg';
import cardirectionSvg from '../../resources/images/car_direction.svg';
import directionWhite from '../../resources/images/direction-white.svg';
import directionSvg from '../../resources/images/direction.svg';
import animalSvg from '../../resources/images/icon/animal.svg';
import bicycleSvg from '../../resources/images/icon/bicycle.svg';
import boatSvg from '../../resources/images/icon/boat.svg';
import busSvg from '../../resources/images/icon/bus.svg';
import carSvg from '../../resources/images/icon/car.svg';
import craneSvg from '../../resources/images/icon/crane.svg';
import crossSvg from '../../resources/images/icon/cross.svg';
import defaultSvg from '../../resources/images/icon/default.svg';
import helicopterSvg from '../../resources/images/icon/helicopter.svg';
import motorcycleSvg from '../../resources/images/icon/motorcycle.svg';
import offroadSvg from '../../resources/images/icon/offroad.svg';
import personSvg from '../../resources/images/icon/person.svg';
import pickupSvg from '../../resources/images/icon/pickup.svg';
import planeSvg from '../../resources/images/icon/plane.svg';
import scooterSvg from '../../resources/images/icon/scooter.svg';
import shipSvg from '../../resources/images/icon/ship.svg';
import stopSvg from '../../resources/images/icon/stop.svg';
import tractorSvg from '../../resources/images/icon/tractor.svg';
import trainSvg from '../../resources/images/icon/train.svg';
import tramSvg from '../../resources/images/icon/tram.svg';
import trolleybusSvg from '../../resources/images/icon/trolleybus.svg';
import truckSvg from '../../resources/images/icon/truck.svg';
import vanSvg from '../../resources/images/icon/van.svg';

export const mapIcons = {
  animal: animalSvg,
  bicycle: bicycleSvg,
  boat: boatSvg,
  bus: busSvg,
  car: carSvg,
  crane: craneSvg,
  default: defaultSvg,
  helicopter: helicopterSvg,
  motorcycle: motorcycleSvg,
  offroad: offroadSvg,
  person: personSvg,
  pickup: pickupSvg,
  plane: planeSvg,
  scooter: scooterSvg,
  ship: shipSvg,
  stop: stopSvg,
  tractor: tractorSvg,
  train: trainSvg,
  tram: tramSvg,
  trolleybus: trolleybusSvg,
  truck: truckSvg,
  van: vanSvg,
  cross: crossSvg,
  cluster: clusterSvg,
  carDirection: cardirectionSvg,
  arrow: arrowPng
};

export const mapIconKey = (category) => (mapIcons.hasOwnProperty(category) ? category : 'default');

export const mapImages = {};

const doPreloadImages = async () => {
  console.info('[preloadImages] iniciando carga de íconos del mapa');

  console.info('[preloadImages] cargando background.svg');
  const background = await loadImage(backgroundSvg);
  console.info('[preloadImages] background.svg OK');

  console.info('[preloadImages] cargando background_invisible.svg');
  const altBackground = await loadImage(altbackgroundSvg);
  console.info('[preloadImages] background_invisible.svg OK');

  console.info('[preloadImages] cargando backgroundCluster.svg');
  const cluster = await loadImage(clusterSvg);
  mapImages.cluster = await prepareIcon(cluster);
  console.info('[preloadImages] backgroundCluster.svg OK');

  console.info('[preloadImages] cargando direction.svg');
  mapImages.direction = await prepareIcon(await loadImage(directionSvg));
  console.info('[preloadImages] direction.svg OK');

  console.info('[preloadImages] cargando direction-white.svg');
  mapImages.directionWhite = await prepareIcon(await loadImage(directionWhite), null, palette.colors.white);
  console.info('[preloadImages] direction-white.svg OK');

  mapImages.background = prepareIcon(background);

  const expectedKeys = [];
  console.info(`[preloadImages] cargando ${Object.keys(mapIcons).length} categorías x 4 colores`);
  await Promise.all(Object.keys(mapIcons).map(async (category) => {
    const results = [];
    ['primary', 'positive', 'negative', 'neutral'].forEach((color) => {
      const key = `${category}-${color}`;
      expectedKeys.push(key);
      const imagePath = mapIcons[category];
      results.push(loadImage(imagePath).then((icon) => {
        mapImages[key] = prepareIcon(altBackground, icon, palette.colors[color]);
        console.info(`[preloadImages] ${key} OK`);
      }).catch((error) => {
        console.error(`[preloadImages] ${key} FALLÓ:`, error?.message || error);
        // Antes este error se tragaba en silencio, sin log ni Sentry.
        // Si prepareIcon() falla (ej. por soporte limitado de
        // OffscreenCanvas/getContext('2d') en ciertos navegadores), la
        // clave nunca se crea en mapImages, y el chequeo de
        // "missingKeys" en MapView.jsx no lo detecta porque solo mira
        // claves ya existentes. Reportamos explícitamente cuál ícono y
        // color fallaron, y por qué.
        // Sentry.captureException(error, {
        //   level: 'warning',
        //   extra: {
        //     context: 'prepareIcon individual',
        //     category,
        //     color,
        //     key,
        //     imagePath,
        //     offscreenCanvasSupported: typeof OffscreenCanvas !== 'undefined',
        //     userAgent: navigator.userAgent,
        //   },
        // });
      }));
    });
    await Promise.all(results);
  }));

  // Verificación final: comparamos cuántos íconos deberíamos tener vs
  // cuántos realmente se generaron. Si faltan muchos (o todos), esto lo
  // va a mostrar de forma explícita, sin depender de que cada catch
  // individual haya funcionado bien.
  const actualKeys = expectedKeys.filter((key) => !!mapImages[key]);
  console.info(`[preloadImages] terminado: ${actualKeys.length}/${expectedKeys.length} íconos cargados`);
  if (actualKeys.length < expectedKeys.length) {
    // Sentry.captureMessage('preloadImages terminó con íconos faltantes', {
    //   level: 'error',
    //   extra: {
    //     expectedCount: expectedKeys.length,
    //     actualCount: actualKeys.length,
    //     missingKeys: expectedKeys.filter((key) => !mapImages[key]),
    //     offscreenCanvasSupported: typeof OffscreenCanvas !== 'undefined',
    //     userAgent: navigator.userAgent,
    //   },
    // });
  }
};

// -----------------------------------------------------------------
// Antes, cada llamador (index.jsx vía setTimeout, y MapView.jsx al
// disparar 'load' del mapa) corría de forma completamente
// independiente. Si el evento 'load' del mapa llegaba antes de que
// esta promesa terminara (común en celulares con CPU/red lenta),
// initMap() leía mapImages vacío y nunca reintentaba, dejando el mapa
// sin íconos de forma silenciosa y permanente.
//
// Ahora exponemos una promesa singleton: sin importar quién la
// invoque primero, todos esperan la misma promesa compartida, y solo
// se ejecuta una vez.
// -----------------------------------------------------------------
let preloadPromise = null;

export default () => {
  if (!preloadPromise) {
    preloadPromise = doPreloadImages();
  }
  return preloadPromise;
};